<template>
    <div v-click-outside="hideDropDownList" class="relative inline-block align-top">
        <span @click.prevent="dropdownVisible = !dropdownVisible"
              class="text-white md:text-gray-700 cursor-pointer hover:text-indigo-600 transition duration-300">
            <svg class="w-6 h-6" viewBox="0 0 24 24" :class="{'blink' : hasNewNotifications && !dropdownVisible && iconBlink}">
                <path v-if="hasNewNotifications" fill="currentColor"
                      d="M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21M19.75,3.19L18.33,4.61C20.04,6.3 21,8.6 21,11H23C23,8.07 21.84,5.25 19.75,3.19M1,11H3C3,8.6 3.96,6.3 5.67,4.61L4.25,3.19C2.16,5.25 1,8.07 1,11Z"/>
                <path v-else fill="currentColor"
                      d="M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21"/>
            </svg>
        </span>

        <transition name="slide-fade">
            <div v-show="dropdownVisible"
                 class="absolute top-8 right-0 bg-white shadow-lg rounded-xl overflow-hidden"
                 style="min-width: 320px; border-top: 3px solid rgb(226, 27, 34);">
                <!-- Notification DropDown Header-->
                <h3 class="p-2 pb-3 pl-3 text-md leading-6 font-medium text-gray-900">
                    Notifications
                </h3>
                <div class="border-b border-gray-200 overflow-y-scroll" style="max-height: 400px">
                    <ul v-if="systemNotifications && systemNotifications.length > 0" class="block">
                        <li v-for="notification in systemNotifications" :key="notification.id"
                            class="px-4 py-4">
                            <system-notification-list-item
                                @show-in-notification-modal="showInModal(notification)"
                                :notification="notification">
                            </system-notification-list-item>
                        </li>
                    </ul>
                    <div v-else class="text-sm text-brand font-medium text-center py-12">
                        No Notifications Yet
                    </div>
                </div>
                <div v-if="systemNotifications" class="py-2 px-3 flex justify-between">
                    <div>
                        <a href="#" v-if="hasMoreToLoad"
                           @click.prevent="loadMore"
                           class="text-xs leading-6 font-medium text-gray-400 hover:text-gray-600">
                            load more ...
                        </a>
                        <span v-else class="text-xs leading-6 font-medium text-gray-400">
                            no more notifications
                        </span>
                    </div>
                    <div v-if="hasNewNotificationsNotRequiringAcknowledgement"
                         @click.prevent="markAllAsSeen" class="cursor-pointer text-xs leading-6 font-medium text-gray-400 hover:text-blue-600">
                        mark all seen
                    </div>
                </div>
            </div>
        </transition>

        <system-notification-modal ref="modal"
                                   :notifications-array="notificationsForModal"
        ></system-notification-modal>
    </div>
</template>

<script>
export default {
    name: "SystemNotificationList",
    data () {
        return {
            dropdownVisible: false,
            queryLimit: 10,
            systemNotifications: [],
            notificationsForModal: [],
            iconBlink: true,
            urlPath: null,
            hasMoreToLoad: true,
        };
    },
    created () {
        this.fetchInitialNotifications();
        this.urlPath = (new URL(window.location.href)).pathname;
        let self = this;
        Bus.$on("notification-updated", function (updatedNotification) {
            let mainListIndex = self.systemNotifications.findIndex(n => n.pivot.id === updatedNotification.pivot.id);
            self.systemNotifications.splice(mainListIndex, 1, updatedNotification);
        });
    },
    mounted () {
        let self = this;
        setTimeout(function () {
            self.iconBlink = false;
        }, 5000);
    },
    computed: {
        hasNewNotifications () {
            return (this.systemNotifications.filter(notification => {
                return notification.pivot.status == "new";
            })).length > 0;
        },
        hasNewNotificationsNotRequiringAcknowledgement () {
            return (this.systemNotifications.filter(notification => {
                return notification.pivot.status == "new" && notification.requires_acknowledgement == 0;
            })).length > 0;
        },
    },
    methods: {
        // This method filters the systemNotifications that's being loaded initially to check if any of them
        // meet all the requirements to be displayed automatically in the popup modal when the page loads. If there
        // matches they will all be included in the array that is being passed to the modal and then the modal is shown
        autoDisplayModal () {
            let autoModalNotifications = this.systemNotifications.filter(this.filterShouldAutoDisplayInModal);
            if (autoModalNotifications.length > 0) {
                this.notificationsForModal = autoModalNotifications;
                this.$refs.modal.toggleNotificationModal();
            }
        },

        filterShouldAutoDisplayInModal (notification) {
            let pageUrlMatch = false;
            // This switch case handles the exceptions where the option is not matching the route
            // or asset groups since 'assets' is also contained so we first want to check if it is a
            // asset group route before we fall back to asset routes if the option is assets
            switch (notification.show_modal_on) {
                case "any_page":
                    pageUrlMatch = true;
                    break;
                case "home_dashboard":
                    pageUrlMatch = this.urlPath == "/";
                    break;
                case "assets":
                    pageUrlMatch = !this.urlPath.includes("/assets/groups") && this.urlPath.includes("/assets");
                    break;
                default:
                    pageUrlMatch = this.urlPath.includes(notification.show_modal_on);
            }
            return pageUrlMatch == true
                && notification.pivot.status == "new"
                && notification.auto_display_modal == true
                && notification.has_more_detail == true;
        },

        // This method is used to display a single notification in the modal
        // so it clears the array and just passes the selected notification
        showInModal (notification) {
            this.notificationsForModal = [notification];
            this.$refs.modal.toggleNotificationModal();
        },

        fetchInitialNotifications () {
            axios.get("/system-notifications", new AppForm({}))
            .then(response => {
                this.systemNotifications = response.data;
                if (response.data.length < this.queryLimit) {
                    this.hasMoreToLoad = false;
                }
                this.autoDisplayModal();
            });
        },

        loadMore () {
            let alreadyLoaded = this.systemNotifications.map(n => n.id);
            axios.get("/system-notifications", {
                params: {
                    limit: this.queryLimit,
                    already_loaded: alreadyLoaded
                },
            }).then((response) => {
                response.data.forEach((notification) => {
                    this.systemNotifications.push(notification);
                });
                if (response.data.length < this.queryLimit) {
                    this.hasMoreToLoad = false;
                }
            }).catch((errors) => {
                toastr.error("Could not fetch more items");
            });
        },

        markAllAsSeen () {
            App.patch("/system-notifications/mark-all-seen", new AppForm({}))
            .then(() => {
                this.systemNotifications = [];
                this.fetchInitialNotifications();
                toastr.success("Notifications Updated");
            }).catch(() => {
                toastr.error("Could not update notifications");
            });
        },

        hideDropDownList () {
            this.dropdownVisible = false;
        },
    }
};
</script>

<style scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
    transition: all .1s ease;
}

.slide-fade-leave-active {
    transition: all .06s cubic-bezier(.54, .81, .83, .67);
}

.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
{
    transform: translateX(10px);
    opacity: 0;
}

/* width */
.overflow-y-scroll::-webkit-scrollbar {
    width: 5px;
}

/* Track */
.overflow-y-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
.overflow-y-scroll::-webkit-scrollbar-thumb {
    background: #adadad;
}

/* Handle on hover */
.overflow-y-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.blink {
    animation: blinker 1.2s linear infinite;
}

@keyframes blinker {
    60% {
        color: #ffffff
    }
}
</style>
